import { useEffect, useState } from 'react';
export const useDataHook = (useSearchVariablesQueryHook, isRefreshed, variableListInput, setIsLoading, setIsRefresh) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const { data: variablesList, loading: variablesListLoading, refetch: refreshVariablesList, } = useSearchVariablesQueryHook(variableListInput);
    useEffect(() => {
        if (isRefreshed) {
            refreshVariablesList();
            setIsRefresh?.(false);
        }
    }, [isRefreshed]);
    useEffect(() => {
        try {
            if (variablesList && !variablesListLoading) {
                const parseData = variablesList.data.map((variable) => {
                    const { id, name, variable_type, sensitive, values, org, } = variable;
                    return {
                        id,
                        name,
                        variable_type,
                        sensitive,
                        values,
                        valuesCount: values?.length || 0,
                        isChecked: false,
                        owner_org_id: org?.id != null ? String(org.id) : undefined,
                        owner_org_name: org?.name,
                    };
                });
                setData(parseData);
                setLoading(false);
                setIsLoading?.(false);
                setIsRefresh?.(false);
            }
        }
        catch (err) {
            setError(true);
            setLoading(false);
            setIsLoading?.(false);
            setIsRefresh?.(false);
        }
    }, [variablesList, variablesListLoading]);
    return {
        data,
        loading,
        error,
        isLastBatch: variablesList?.last_batch || false,
        refetch: refreshVariablesList,
    };
};
//# sourceMappingURL=useDataHook.js.map